import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell, ResponsiveContainer } from 'recharts'
import stringHelpers from '../../../utilities/stringHelpers'

const COLOUR = "#4E79A7"

const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null
    const { name, value } = payload[0].payload

    return (
        <div className="analytics-tooltip">
            <div className="analytics-tooltip-header">
                <span className="analytics-tooltip-dot" style={ { background: payload[0].fill } } />
                <span className="analytics-tooltip-name">{ name }</span>
            </div>
            <span className="analytics-tooltip-value">{ stringHelpers.formatDecimal(value, 0) } vehicle{ value !== 1 ? "s" : "" }</span>
        </div>
    )
}

export const ManufactureYearBarChart = ({ breakdown }) => {
    const data = Object.entries(breakdown)
        .filter(([name]) => name !== "UNKNOWN")
        .map(([name, value]) => ({ name, value }))
        .sort((a, b) => a.name.localeCompare(b.name))

    return (
        <div className="analytics-chart-card">
            <p className="analytics-chart-title mb-3">Manufacture Year</p>
            <ResponsiveContainer width="100%" height={ 250 }>
                <BarChart data={ data } margin={ { top: 0, right: 16, bottom: 8, left: 0 } }>
                    <XAxis type="category" dataKey="name" tick={ { fontSize: 11, fill: "#4a5568" } } axisLine={ false } tickLine={ false } />
                    <YAxis tick={ { fontSize: 11, fill: "#a0aec0" } } axisLine={ false } tickLine={ false } allowDecimals={ false } />
                    <Tooltip content={ <CustomTooltip /> } cursor={ { fill: "#f7fafc" } } />
                    <Bar dataKey="value" radius={ [6, 6, 0, 0] } maxBarSize={ 36 } fill={ COLOUR } />
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}
